import { MessageModalTypes } from '~/definitions/messageModal';
import { getStore } from '~/mobx/AppStore';

export const showMessageModal = (type: MessageModalTypes, message: string | JSX.Element) => {
    const messageModalStore = getStore().messageModalStore;
    messageModalStore.setType(type);
    messageModalStore.setMessage(message);
    messageModalStore.setIsOpen(true);
};
